'use client';

import { css } from '@bts-web/utils-style-engine';
import { getAppConfig, CURRENCY } from '@bts-web/core-app-config';
import { RegularEuro } from '../../../../common/svgIcons';

// TODO: replace AED and GBP with their respective currency icons once available in the icon library
const CURRENCY_ICON_MAP: Record<CURRENCY, typeof RegularEuro> = {
  EUR: RegularEuro,
  AED: RegularEuro,
  GBP: RegularEuro,
};

interface FiatSymbolIconProps {
  iconSize?: number;
  containerSize?: number;
}

export const FiatSymbolIcon = ({
  iconSize = 40,
  containerSize = 40,
}: FiatSymbolIconProps) => {
  const { currency } = getAppConfig();

  const CurrencyIcon = CURRENCY_ICON_MAP[currency];

  return (
    <span
      className={css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        color: 'neutrals.text_primary_inverted',
        borderRadius: '50%',
        backgroundColor: 'neutrals.fill_primary',
      })}
      style={{ width: containerSize, height: containerSize }}
    >
      <CurrencyIcon size={iconSize} color="neutrals.text_primary_inverted" />
    </span>
  );
};
